module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Share-911991d8b3385e159c713b79d6b4b866.svg";